<div class="card">
  <ng-template #contentTemplate>
    <div class="service__title-wrapper">
      <h3 class="service__title" [innerHTML]="item().title"></h3>
    </div>
    <div class="service__subtitle">
      <span>{{ item().pubDate | parseDate | date: "d MMMM YYYY" : undefined : translate.currentLang }}</span>
      @if (showCreator()) {
        &nbsp;&mdash;&nbsp;<span>{{ creator() }}</span>
      }
    </div>
    @if (summary()) {
      <div class="service__content">
        <p [innerHTML]="description()"></p>
      </div>
    } @else {
      <div [innerHTML]="contentEncoded()"></div>
    }
    <div class="tags">
      @for (tag of categories(); track $index) {
        <div class="tag">{{ tag }}</div>
      }
    </div>
  </ng-template>

  <!-- Wrap the content in a clickable link, if a summary-->
  <a
    *ngIf="summary(); else contentTemplate"
    class="no-style-link"
    style="display: flex; gap: 16px"
    [routerLink]="[item() | getNewsItemLink]"
  >
    <div style="display: flex; flex-direction: column">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    @if (firstImageUrl()) {
      <div style="display: flex; flex-direction: column; width: 600px" [innerHTML]="firstImageUrl()"></div>
    }
  </a>
</div>
